export default __webpack_public_path__ + "static/Artboard 2-08fb5b9bd9c83503cebe77f728ef9216.webp";